import * as React from "react";

import _ from "lodash";
import { Process } from "../../model/Process";

export const DeployDialogHeader: React.FC<DeployDialogHeaderProps> = (props) => {
    let headerText: string;
    if (props.isSwitchVersion) {
        headerText = FRENDS.Localizations.SwitchProcess;
    } else {
        headerText = FRENDS.Localizations.Deploy + " ";
        if (props.selectedProcesses.length > 1) {
            headerText += FRENDS.Localizations.Processes;
        } else {
            headerText += FRENDS.Localizations.Process;
        }
        if (props.hasApiPassthroughConfiguration) {
            headerText += " and API Passthrough Configuration";
        }
    }

    return <h2>{headerText}</h2>;
};

interface DeployDialogHeaderProps {
    isSwitchVersion: boolean;
    hasApiPassthroughConfiguration: boolean;
    selectedProcesses: Process[];
}
